interface IGroupIds {
  [groupId: number]: string
}

interface IGroupIdMapping {
    [groupId: number]: number
}

export const GroupIds: IGroupIds = {
  1: "d90377b7-3fdf-460c-8090-10cf0207b7b4",
  2: "403776a9-934b-46e3-9724-2bc86bab3060",
  3: "9586af9c-9228-4274-9c42-cc9f3163c132",
}

export const GroupIdWeightingMapping: IGroupIdMapping = {
    1: 1,
    2: 2,
    3: 1
}

// Returns Lookers Group Id, in the case that an invalid id is passed
export const getGroupId = (groupId: number): string => {
  return GroupIds[groupId] || GroupIds[1]
}
